import React, { useEffect } from "react";
import { useAppDispatch } from "../../../../../state/store";
import { Loading } from "../../../common/Loading";
import { searchAction } from "../../../../../state/usecase/disease_knowledge/actions";
import { useSearchedDiseases } from "../../../../hooks/disease_knowledge/useSearchedDiseases";
import { SearchResultList } from "./SearchResultList";

export const DiseaseKnowledgeSearchResult = React.memo(function DiseaseKnowledgeSearchResult() {
    const dispatch = useAppDispatch();

    const { isProcessing, keyword } = useSearchedDiseases();

    useEffect(() => {
        if (keyword) {
            dispatch(searchAction(keyword));
        }
    }, [dispatch, keyword]);

    return isProcessing ? (
        <Loading />
    ) : (
        <SearchResultList />
    );
});
